import { createContext } from 'react';

export interface IDeltaDocumentUIContext {
  showOnlyPotencialCandidates: boolean;
  handleShowOnlyPotencialCandidates: (value: boolean) => void;
  shouldBeRefreshCandidates: boolean;
  setShouldBeRefreshCandidates: (value: boolean) => void;
}

const DeltaDocumentUIContext = createContext<IDeltaDocumentUIContext | undefined>(undefined);

export default DeltaDocumentUIContext;
